import styled from 'styled-components';

export const FiltersDetailsContentStyle = {
  Container: styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
  `,
};
